import { render, staticRenderFns } from "./YearsTitleListView.vue?vue&type=template&id=45bc93c4"
import script from "./YearsTitleListView.vue?vue&type=script&lang=js"
export * from "./YearsTitleListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports